
<app-header></app-header>
<app-navbar></app-navbar>

<main class="">
    
   
    <section id="home" class="mt-5 row justify-content-center container-fluid" [@bounce]="bounce">
      <div class="col-md-4 img-home"><br>
        <img src="../../../assets/quemsomos.svg" class="image-slider"
          alt="Quem Somos">
      </div>
      <div class="col-md-4 text-section" >
        <h1>Quem Somos</h1><br>
        <p>  O Argus chegou para simplificar sua operação - ele é robusto, fácil de operar, escalável e muito estável. </p><br>
        <h2 class="text-center text-danger">Atendimento ao Cliente Garantido com o Argus</h2>  <br>
         <h1>Eficiência e produtividade</h1>
          <h3 class="text-right text-danger">para sua operação,</h3>
          <h2>simples na gestão e</h2> 
          <h1 class="text-center text-danger"> robusto na performance. </h1>
           
      </div>
    </section><br><br>
    <section class="hero" id="argus" [@bounce]="bounce"><br>
        <app-argus></app-argus>
      </section>

    <section id="diferenciais" class="mt-5 row justify-content-center container-fluid" [@bounce]="bounce">
        <div class="col-md-4 text-section">
            <h1>Diferenciais</h1><br>
            <ul>
              <li><h6>Sem contrato de permanência </h6></li>
              <li><h6>Intuitivo, fácil de operar</h6></li>
              <li><h6>Não existe perda de gravação</h6></li>
              <li><h6>Desenvolvido por quem usa o sistema</h6></li>
              <li><h6>Tecnologia Própria</h6></li>
              <li><h6>Discagens eficientes</h6></li>
         
            </ul><br>
          </div>
        <div class="col-md-4 img-home">
         &nbsp;&nbsp;&nbsp; <img src="../../../assets/diferenciais.svg" class="image-slider"
            alt="Diferenciais">
        </div>
        
      </section>
      <nav class="navbar navbar-light startnav shadow-lg p-3 mb-5 rounded">
      <section id="contato" class=" row justify-content-center container-fluid" [@bounce]="bounce">
        <div class="col-md-4 img-home">
          <img src="../../../assets/contato.svg" class="image-slider"
            alt="Contato">
        </div>
        <div class="col-md-4 text-section">
          <h1>Contato</h1>
          <p> 

            Entre em contato conosco e saiba mais sobre o Argus, solicite um orçamento <br><br>
                  
            Email: contato@argus4com.com.br  </p>
           
            <form class="forms col-md-12 col-ls-12"   class="mt-4">
                <div class="form-group">
                  <input type="name" class="col-md-8 col-lg-12 form-control" id="exampleFormControlInput1" placeholder="Nome Completo">
                </div>
                <div class="form-group">
                  <input type="text" class="form-control col-md-8 col-lg-12" id="exampleFormControlInput1" placeholder="Assunto">
                </div>
                <div class="form-group">
                  <textarea class="form-control col-md-8 col-lg-12" id="exampleFormControlTextarea1" rows="3"
                    placeholder="Informações aqui"></textarea>
                </div>
                <button type="button submit" value="submit" class="btn btn-danger col-md-8 col-lg-12">Send</button>
              </form><br>
         
        </div>
      </section></nav>
    

    <br>
     

  </main>
   
        <footer class="container-fluid text-center" id="footer">Copyright 2020. Argus4Com - Todos os direitos reservados.
            <p>&nbsp;</p>
        </footer>
